import { render, staticRenderFns } from "./ListStatsFooter.vue?vue&type=template&id=2111357e&"
import script from "./ListStatsFooter.vue?vue&type=script&lang=js&"
export * from "./ListStatsFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports